import { Component, OnInit, Inject, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsEvents } from '@irb-common/events';
import { ImportCashSettingsResultGridLayoutService } from '@irb/irb-clients/import-cash-settings-result-dialog/import-cash-settings-result.grid-layout.service';

@Component({ standalone: false,
  selector: 'irb-import-cash-settings-result-dialog',
  templateUrl: './import-cash-settings-result-dialog.component.html',
  styleUrls: ['./import-cash-settings-result-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportCashSettingsResultDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;

  constructor(
    public dialogRef: MatDialogRef<ImportCashSettingsResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportCashSettingsResultGridLayoutService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    this.as.fireEvent(IrbClientsEvents.IMPORT_CASH_SETTINGS_COMPLETE, this.data);
    this.close();
  }
}
